// extracted by mini-css-extract-plugin
export var menuItem = "W_yd d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "W_yf d_Z d_bz d_bP";
export var menuMainLink = "W_yg d_f0 d_dB";
export var menuLink = "W_yh d_f0 d_dB";
export var icon = "W_n9 d_bC d_bP";
export var divider = "W_yj d_bC d_bP";
export var sublinks = "W_yk";
export var link = "W_mC";
export var Link = "W_tx y_tx y_sP y_s7";